import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import React from 'react';
import MobileAdhesionGak from './gak/MobileAdhesion';
import MobileAdhesionHashtag from './hashtag/MobileAdhesion';
const MobileAdhesion = ({ safety = 'off', safetyState })=>{
    const isHashtag = useFlag('ads_prebid');
    if (isHashtag) {
        return /*#__PURE__*/ React.createElement(MobileAdhesionHashtag, {
            safety: safety,
            safetyState: safetyState
        });
    }
    return /*#__PURE__*/ React.createElement(MobileAdhesionGak, {
        safety: safety,
        safetyState: safetyState
    });
};
MobileAdhesion.displayName = 'MobileAdhesion';
export default MobileAdhesion;
